<template>
  <div class="small">
          <pie-chart :height="300" :chart-data="CHARTDATA"></pie-chart>
  </div>
</template>

<script>
  import PieChart from '@/plugins/PieChart.js'

  export default {
      components: {
        PieChart
      },
        data: () => ({
          labels: [],
          data:[],
          datacollection:{},
          gradient: null,
          pieColors: [
          "#3B82F6", // Blue
          "#10B981", // Emerald
          "#F59E0B", // Amber
          "#EF4444", // Red
          "#8B5CF6", // Purple
          "#06B6D4", // Cyan
          "#EC4899", // Pink
          "#6366F1", // Indigo
          "#F97316", // Orange
          "#84CC16"  // Lime
        ],
      }),
      props: {
        show:{
            type: Boolean,
            default: false
        },
        rawdata: {
          type: Array,
          default: function(){ return []}
        }
      },
    watch: {
      show(v) {
        if(v){
            this.exportData()
            this.fillData(this.data,this.labels)
        }
       
        
      }
    },
    computed: {
      CHARTDATA() {
        return this.datacollection
      }
    },
    methods: {
      exportData() {
        this.labels = []
        this.data = []
       
        for (const item of this.rawdata) {
              this.labels.push(item.cashier + ' ('+ this.$money(item.amount)+')')
              this.data.push(item.amount)
          }
      
      },
      fillData (_data, _labels) {
        
        this.datacollection = {
          labels:_labels,
          datasets: [
            {
              label: this.$moment().format("MMMM") +  " Gross Sales",
              data: _data,
              backgroundColor: this.pieColors
            }
          ]
        }
        // setTimeout(()=>{
        //   this.datacollection.datasets[0].backgroundColor = this.BGCOLOR
        //   console.log(this.datacollection.datasets[0].backgroundColor)
        // }, 1000)
        

      
      }
    }
  }
</script>

<style>
  .small {
    height: 300px;
  }
</style>